import { render, staticRenderFns } from "./Filemanager.vue?vue&type=template&id=5a457978&scoped=true&"
import script from "./Filemanager.vue?vue&type=script&lang=js&"
export * from "./Filemanager.vue?vue&type=script&lang=js&"
import style0 from "./Filemanager.vue?vue&type=style&index=0&id=5a457978&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a457978",
  null
  
)

export default component.exports